/**
 * CSV export utility — converts an array of objects to CSV and triggers download.
 */
const escapeCsv = (val) => {
  if (val === null || val === undefined) return "";
  if (typeof val === "object") val = JSON.stringify(val);
  const s = String(val);
  if (/[",\n\r]/.test(s)) {
    return '"' + s.replace(/"/g, '""') + '"';
  }
  return s;
};

export function downloadCsv(filename, rows, columns) {
  if (!rows || rows.length === 0) {
    return false;
  }
  // columns can be array of strings or array of {key, header}
  let headers, accessors;
  if (typeof columns?.[0] === "string") {
    headers = columns;
    accessors = columns.map((k) => (row) => row[k]);
  } else if (Array.isArray(columns)) {
    headers = columns.map((c) => c.header);
    accessors = columns.map((c) => c.accessor || ((row) => row[c.key]));
  } else {
    headers = Object.keys(rows[0]);
    accessors = headers.map((k) => (row) => row[k]);
  }

  const csv = [
    headers.map(escapeCsv).join(","),
    ...rows.map((r) => accessors.map((fn) => escapeCsv(fn(r))).join(",")),
  ].join("\n");

  const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
  return true;
}
